import {
  ADD_COMPLEMENT_SIGNET,
  ADD_COMPLEMENT_SIGNET_START,
  ADD_COMPLEMENT_SIGNET_ERROR,
  GET_COMPLEMENT_SIGNET_LAST,
  GET_COMPLEMENT_SIGNET_LAST_START,
  GET_COMPLEMENT_SIGNET_LAST_ERROR,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR,
  CLEAR_COMPLEMENT_SINGET,
} from '../actions/types';

const initialState = {
  complementSignetList: [],
  complementSignet: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearComplementSignet = (state) => {
  return {
    ...state,
    complementSignet: {},
  };
};

const addComplementSignetStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addComplementSignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addComplementSignet = (state, action) => {
  return {
    ...state,
    loading: false,
    complementSignet: action.payload,
    complementSignetList: state.complementSignetList.concat([action.payload]),
    error: undefined,
  };
};

const getLastComplementSignetBySignetStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const getLastComplementSignetBySignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const getLastComplementSignetBySignet = (state, action) => {
  return {
    ...state,
    loading: false,
    complementSignet: action.payload,
    error: undefined,
  };
};

const getComplementSignetListBySignetStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const getComplementSignetListBySignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const getComplementSignetListBySignet = (state, action) => {
  return {
    ...state,
    loading: false,
    complementSignetList: action.payload,
    error: undefined,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_COMPLEMENT_SIGNET:
      return addComplementSignet(state, action);
    case ADD_COMPLEMENT_SIGNET_START:
      return addComplementSignetStart(state);
    case ADD_COMPLEMENT_SIGNET_ERROR:
      return addComplementSignetError(state, action);

    case GET_COMPLEMENT_SIGNET_LAST:
      return getLastComplementSignetBySignet(state, action);
    case GET_COMPLEMENT_SIGNET_LAST_START:
      return getLastComplementSignetBySignetStart(state);
    case GET_COMPLEMENT_SIGNET_LAST_ERROR:
      return getLastComplementSignetBySignetError(state, action);

    case GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET:
      return getComplementSignetListBySignet(state, action);
    case GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START:
      return getComplementSignetListBySignetStart(state);
    case GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR:
      return getComplementSignetListBySignetError(state, action);

    case CLEAR_COMPLEMENT_SINGET:
      return clearComplementSignet(state);

    default:
      return state;
  }
}
